<template><SimpleModuleDashboard :module-id="Modules.CONTENIDOS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="dashboardActions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    havePage: Helper.hasParametersAccess(Param.P15),
    havePortabilityTemplate: Helper.hasParametersAccess(Param.P45),
  }),
  computed: {
    dashboardActions() {
      const actions = [{ id: 'crudSettings', reference: 'crudSettings', route: 'ContentsSttaffSettings', tone: 'primary' }]
      if(this.havePage) actions.push({ id: 'crudPages', reference: 'crudPages', route: 'ContentsSttaffPages', tone: 'secondary' })
      actions.push({ id: 'crudTemplate', reference: 'crudTemplate', route: 'ContentsStaffTemplate', tone: 'success' })
      if(this.havePortabilityTemplate) actions.push({ id: 'crudPortabilityTemplate', reference: 'crudPortabilityTemplate', route: 'ContentsStaffPortabilityTemplate', tone: 'warning' })
      return actions
    },
  },
}
</script>
